module.exports = __webpack_public_path__ + "static/img/帽子.02f8318.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/帽子/帽子.jpeg
// module id = 8cHj
// module chunks = 0